const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

export function formatPriceInCents(priceInCents: number): string {
  return brlFormatter.format(priceInCents / 100)
}
